import * as React from 'react';
import '../styles/App.css';

class MainContentSection extends React.Component {
  render() {
    return (
        <div className="MainContentSection">
            <div className="ComingSoonSection">
            <table className="ComingSoonTable">
                <tbody>
                    <tr>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                            <div className="ComingSoonText">Coming Soon!</div>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    );
  }
}

export default MainContentSection;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/MainContentSection.tsx